
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Attachment, AttachmentTypeOptions } from '@/types';

@Component
export default class AttachmentType extends Vue {
  @Prop(Object) readonly attachment!: Attachment

  get typeLong(): string {
    return this.attachment.fieldname in AttachmentTypeOptions
      ? AttachmentTypeOptions[this.attachment.fieldname] : 'Sconosciuto';
  }
}
